import lodash from 'lodash';
import toastr from 'toastr';
import '../../node_modules/toastr/build/toastr.css';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import popper from 'popper.js'
import moment from 'moment';

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.moment = moment
window._ = lodash;

toastr.options.closeButton = true;
window.toastr = toastr;

// show a one-off message the server flashed with ->with('toast', ...)
const flashToast = document.querySelector('meta[name="flash-toast"]');

if (flashToast) {
	toastr.success(flashToast.content, null, { escapeHtml: true });
}

try {
	window.Popper = popper
} catch (e) {
	//
}
